/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Stack, Text, Select, Alert, Checkbox, Group, Paper, Title, Divider } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { useCallback, useEffect, useMemo, type ChangeEvent } from "react";
import { useEmpresasForTemplate } from "../../../../empresas/hooks/useEmpresasForTemplate";
import { useLicenciadaMaster } from "../../../hooks/useLicenciadaMaster";
import { TemplateStepProperties } from "../types";

// Collections disponíveis organizadas por categoria
const COLLECTIONS_CONFIG = {
  regulamentos: {
    title: "Gestão de Inovação",
    collections: [
      { value: "regulamentosIdeias", label: "Regulamentos de Ideias" },
      { value: "regulamentosDesafios", label: "Regulamentos de Desafios" },
      { value: "desafioCategorias", label: "Categorias de Desafios" },
    ]
  },
  diagnostico: {
    title: "Diagnóstico",
    collections: [
      { value: "projetos", label: "Projetos" },
      { value: "questionarios", label: "Questionários" },
      { value: "tiposDeRespostas", label: "Tipos de Respostas" },
      { value: "gruposDiagnostico", label: "Grupos de Perguntas" },
      { value: "perguntas", label: "Perguntas" }
    ]
  },
  inovacao: {
    title: "Incentivo a Inovação",
    collections: [
      { value: "tipoDeJogada", label: "Tipo de Jogadas" },
      { value: "tipoDeInovacao", label: "Tipo de Inovação" },
      { value: "jogadaDeInovacao", label: "Jogada de Inovação" },
      { value: "categoriaDeInovacao", label: "Categoria de Inovação" }
    ]
  },
  outros: {
    title: "Outros",
    collections: [
      { value: "autorizacao", label: "Autorizações" },
      { value: "configuracoesFormularioIdeias", label: "Configurações do Formulário de Ideias" },
    ]
  }
};

export const TemplateSelectionStep = ({ form }: TemplateStepProperties) => {
  const licenciadaMasterQuery = useLicenciadaMaster();
  const licenciadaMaster = licenciadaMasterQuery.data;
  const empresasQuery = useEmpresasForTemplate(licenciadaMaster?.id);

  // Atualiza automaticamente o licenciadaId quando a licenciada master é carregada
  useEffect(() => {
    if (licenciadaMaster?.id) {
      form.setFieldValue("template.licenciadaId", licenciadaMaster.id);
    }
  }, [licenciadaMaster, form]);

  const empresasData = useMemo(() => empresasQuery.data || [], [empresasQuery.data]);

  const empresaPlaceholder = useMemo(
    () => (empresasQuery.isLoading ? "Carregando..." : "Selecione uma empresa"),
    [empresasQuery.isLoading]
  );

  const empresaDisabled = useMemo(
    () => !licenciadaMaster?.id || empresasQuery.isLoading || licenciadaMasterQuery.isLoading,
    [licenciadaMaster, empresasQuery.isLoading, licenciadaMasterQuery.isLoading]
  );

  const showEmptyMessage = useMemo(
    () => licenciadaMaster?.id && empresasQuery.data && empresasQuery.data.length === 0,
    [licenciadaMaster, empresasQuery.data]
  );

  const showErrorMessage = licenciadaMasterQuery.isError;

  // Handler para checkbox de collection
  const handleCollectionToggle = useCallback((collectionValue: string) => {
    const currentCollections = form.values.template.collections || [];
    const isChecked = currentCollections.includes(collectionValue);

    if (isChecked) {
      // Remove da lista
      form.setFieldValue(
        "template.collections",
        currentCollections.filter((c) => c !== collectionValue)
      );
    } else {
      // Adiciona na lista
      form.setFieldValue("template.collections", [...currentCollections, collectionValue]);
    }
  }, [form.setFieldValue, form.values.template.collections]);

  const handleCollectionChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const collectionValue = event.currentTarget.dataset.collectionValue;
      if (!collectionValue) {
        return;
      }
      handleCollectionToggle(collectionValue);
    },
    [handleCollectionToggle]
  );

  return (
    <Stack gap="sm" mt="md">
      <Title order={3} mb="xs">Passo 3: Seleção de Modelo</Title>
      <Text size="sm" c="dimmed" mb="md">
        Selecione a empresa modelo que servirá como base para clonar questionários, tipos de resposta, grupos e
        perguntas. A licenciada modelo será buscada automaticamente da configuração geral.
      </Text>
      <Divider mb="md" />

      {showErrorMessage && (
        <Alert icon={<IconInfoCircle size="1rem" />} title="Erro ao carregar licenciada master" color="red">
          Não foi possível carregar a licenciada master. Verifique se ela está configurada em /config/geral.
        </Alert>
      )}

      {licenciadaMasterQuery.isLoading && (
        <Alert icon={<IconInfoCircle size="1rem" />} title="Carregando" color="blue">
          Buscando licenciada master...
        </Alert>
      )}

      {licenciadaMaster && (
        <Alert icon={<IconInfoCircle size="1rem" />} title="Licenciada Master" color="green">
          Usando licenciada master configurada: {licenciadaMaster.razaoSocial}
        </Alert>
      )}

      <Select
        label="Empresa Modelo"
        placeholder={empresaPlaceholder}
        data={empresasData}
        {...form.getInputProps("template.empresaId")}
        disabled={empresaDisabled}
        searchable
        required
      />

      {showEmptyMessage && (
        <Text size="sm" c="orange">
          Nenhuma empresa encontrada para a licenciada master.
        </Text>
      )}

      <Text size="sm" fw={500} mt="xl" mb="xs">
        Selecione o que deseja importar:
      </Text>

      {Object.entries(COLLECTIONS_CONFIG).map(([key, config]) => (
        <Paper key={key} p="md" withBorder>
          <Title order={6} mb="sm">
            {config.title}
          </Title>
          <Group gap="md">
            {config.collections.map((collection) => (
              <Checkbox
                key={collection.value}
                label={collection.label}
                checked={form.values.template.collections?.includes(collection.value) || false}
                data-collection-value={collection.value}
                onChange={handleCollectionChange}
              />
            ))}
          </Group>
        </Paper>
      ))}
    </Stack>
  );
};
